import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);
  const recentArticles = articles.filter((a) => !a.featured);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-100 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-400 text-sm">为你精选的优质自拍指南内容</p>
          </div>
          <Link
            to="/category/shooting-tips"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-12">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="flex items-center justify-between mb-6">
          <h3 className="font-heading text-xl font-semibold text-foreground-100">
            最新文章
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {recentArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/shooting-tips"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-primary-300 text-primary-500 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}